import angular from 'angular';

export default angular
  .module('books.ui.genderSelect', [])
  .component('genderSelect', {
    bindings: { model: '=ngModel' },
    require: { ngModel: '' },
    template:
      '<select class="form-control" ng-options="option.label for option in $ctrl.genders track by option.value" ng-model="$ctrl.selected"></select>',
    controller: Controller
  }).name;

/* @ngInject */
function Controller($injector, $scope) {
  var $svcs = { $ctrl: this, $scope: $scope };

  $injector.invoke(initCtrl, null, Object.assign($svcs, { $svcs: $svcs }));
}

/*******************************************************************************
 * initCtrl */
/**
 * Initializes the Controller object.
 *******************************************************************************/
/* @ngInject */ function initCtrl($ctrl, $injector, SERVER) {
  $ctrl.genders = [
    { label: 'Unspecified', value: null },
    { label: 'Male', value: SERVER.BooksDBConstants.GT_MALE },
    { label: 'Female', value: SERVER.BooksDBConstants.GT_FEMALE }
  ];

  Object.defineProperty($ctrl, 'selected', {
    get: function () {
      var list = $ctrl.genders.filter(function (g) {
        return g.value == $ctrl.model;
      });

      /*--------------------------------------------*/
      /* Return the matching gender. If no match    */
      /* is found, return the "Unspecified" gender. */
      /*--------------------------------------------*/
      return list.length > 0 ? list[0] : $ctrl.genders[0];
    },
    set: function (selected) {
      $ctrl.model = selected.value;
    }
  });
}
